// Generated by CoffeeScript 1.9.1
var Columns, Model, _;
Model = require("backbone-thin").Model;
_ = require("underscore");
module.exports = Columns = Model.extend({
  initialize: function initialize(o, stat) {
    if (this.get("hidden") == null) {
      this.set("hidden", []);
    }
    return this.stats = stat;
  },
  calcHiddenColumns: function calcHiddenColumns(n) {
    var hidden, i, j, len, newX;
    hidden = this.get("hidden");
    newX = n;
    for (j = 0, len = hidden.length; j < len; j++) {
      i = hidden[j];
      if (i <= newX) {
        newX++;
      }
    }
    return newX - n;
  }
});